"use strict";

(function () {
  var content = document.querySelector(".affiliate-content");
  var beforeNode = document.querySelector(".affiliate-content .affiliate-intro");
  var readMore = document.createElement("span");
  readMore.classList.add("read-more");
  readMore.innerHTML = "\n        <button>read more</button>\n";
  var desc = document.querySelector(".affiliate-intro");
  function checkOverflow() {
    if (desc.scrollHeight > desc.clientHeight) {
      readMore.classList.add("block");
      content.insertBefore(readMore, beforeNode);
    }
  }
  checkOverflow();
  readMore.addEventListener("click", function () {
    if (desc.classList.contains("expanded")) {
      content.insertBefore(readMore, beforeNode);
      desc.classList.remove("expanded");
      readMore.classList.remove("inline");
      readMore.classList.add("block");
      readMore.querySelector("button").textContent = "read more";
    } else {
      desc.classList.add("expanded");
      content.removeChild(readMore);
      readMore.classList.remove("block");
      readMore.classList.add("inline");
      desc.classList.add("expanded");
      readMore.querySelector("button").textContent = "read less";
      readMore.style.position = "relative";
      desc.querySelector("p:last-child").appendChild(readMore);
    }
  });
})();